import { render } from "./LeadsSearch.vue?vue&type=template&id=8c63d8e2&scoped=true"
import script from "./LeadsSearch.vue?vue&type=script&lang=js"
export * from "./LeadsSearch.vue?vue&type=script&lang=js"

import "./LeadsSearch.vue?vue&type=style&index=0&id=8c63d8e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c63d8e2"]])

export default __exports__